import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private Offers Types */
import {
  Settings,
  _Offer
} from '../namespace-helper'

import _ from 'lodash'

const selectedOfferTemplate = {
  id: 0,
  customers_id: 0,
  accounts_id: 0,
  inquiries_id: 0,
  offer_number: '',
  valid_until: '',
  currencies_id: 0,
  customers_offers_status_id: 0,
  messages_id: null,
  currency: {
    name: ''
  }
}

export default {
  namespaced: true,
  state: {
    offers: [],
    unconfirmedOffers: [],
    setSelectedOffer: _.cloneDeep(selectedOfferTemplate),
    openDialog: false,
    creatingCustomerOfferFromInquiry: false,
    customerOfferDocumentViewToken: null
  },
  mutations: {
    [_Offer.mutations.setOffers] (state, payload) {
      state.offers = payload
    },
    [_Offer.mutations.setUnconfirmedOffers] (state, payload) {
      state.unconfirmedOffers = payload
    },
    [_Offer.mutations.setSelectedOffer] (state, payload) {
      if (payload !== null) {
        state.setSelectedOffer = payload
      } else {
        state.setSelectedOffer = _.cloneDeep(selectedOfferTemplate)
      }
    },
    [_Offer.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    },
    [_Offer.mutations.setCreatingOfferForInquiry] (state, payload) {
      state.creatingCustomerOfferFromInquiry = payload
    },
    [_Offer.mutations.setCustomerOfferDocumentViewToken] (state, payload) {
      state.customerOfferDocumentViewToken = payload
    }
  },
  actions: {
    [_Offer.actions.saveOffer] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/customerOffers'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            context.commit(_Offer.mutations.setSelectedOffer, r.data.data)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/customerOffers/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            context.commit(_Offer.mutations.setSelectedOffer, r.data.data)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_Offer.actions.loadOffers] (context, payload) {
      console.log('loadOffers: ' + JSON.stringify(payload))
      console.log('loadOffers: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/customerOffers?limit=' + payload.limit +
                '&page=' + payload.page +
                '&search=' + payload.search +
                '&searchFields=id:like;' +
                'offer_number:like;' +
                'customer.name:like;' +
                'account.firstname:like;' +
                'customersOffersStatus.name:like;' +
                'inquiry.project_number:like;' +
                'inquiry.rfq_number:like;' +
                'customersOffersPositions.product.reference:like;' +
                'inquiry.inquiresPositions.internal_number:like' +
                '&orderBy=' + payload.sortBy +
                '&sortedBy=' + payload.descending +
                '&customersId=' + payload.customers_id +
      /*                (payload.selectedFrom ? '&selectedFrom=' + payload.selectedFrom : '') +
                (payload.selectedTo ? '&selectedTo=' + payload.selectedTo : '') +
                (payload.filterDates ? '&filterDates=' + JSON.stringify(payload.filterDates) : '') + */
                (payload.selectedOfferFollowUpStatuses ? '&selectedOfferFollowUpStatuses=' + JSON.stringify(payload.selectedOfferFollowUpStatuses) : '') +
                (payload.selectedOfferStatuses ? '&selectedOfferStatuses=' + JSON.stringify(payload.selectedOfferStatuses) : '')

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        console.log('loadedOffers: ' + JSON.stringify(r.data.data))
        context.commit(_Offer.mutations.setOffers, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },

    [_Offer.actions.loadUnconfirmedOffers] (context, payload) {
      console.log('loadUnconfirmedOffers: ' + JSON.stringify(payload))
      console.log('loadUnconfirmedOffers: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/customerOffers/' + payload.customers_id + '/unconfirmed?limit=' + payload.limit +
              '&page=' + payload.page +
              '&search=' + payload.search +
              '&searchFields=id:like;offer_number:like;customer.name:like;account.firstname:like;customersOffersStatus.name:like;inquiry.rfq_number:like;rfq_number:like;customersOffersPositions.internal_number:like;inquiry.inquiresPositions.internal_number:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        console.log('loadUnconfirmedOffers: ' + JSON.stringify(r.data.data))
        context.commit(_Offer.mutations.setUnconfirmedOffers, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_Offer.actions.openCloseDialog] ({ commit }) {
      commit(_Offer.mutations.setOpenCloseDialogState)
    },
    [_Offer.actions.setSelectedOffer] ({ commit }, payload) {
      commit(_Offer.mutations.setSelectedOffer, payload)
    },
    [_Offer.actions.createForInquiry] (context, payload) {
      context.commit(_Offer.mutations.setCreatingOfferForInquiry, true)

      const data = JSON.stringify(payload)

      var url = API_URL + '/api/v1/customerOffers/createFromInquiry'
      return new Promise((resolve, reject) => {
        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_Offer.mutations.setCreatingOfferForInquiry, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          context.commit(_Offer.mutations.setCreatingOfferForInquiry, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Offer.actions.createCustomerOfferMessage] (context, payload) {
      context.commit(_Offer.mutations.setCreatingOfferForInquiry, true)

      var url = API_URL + '/api/v1/customerOffers/' + payload + '/createCustomerOfferMessage'
      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_Offer.mutations.setCreatingOfferForInquiry, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          context.commit(_Offer.mutations.setCreatingOfferForInquiry, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Offer.actions.reloadSelectedCustomerOffer] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      var url = API_URL + '/api/v1/customerOffers/' + payload
      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_Offer.mutations.setSelectedOffer, r.data.data)
          resolve(r)
        }, function (err) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Offer.actions.getDocumentViewTokenByCustomerOfferId] (context, payload) {
      console.log('getDocumentViewTokenByCustomerOfferId: ' + JSON.stringify(payload))
      var url = API_URL + '/api/v1/customerOffers/documentToken/' + payload.id + '?filename=' + payload.filename

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_Offer.mutations.setCustomerOfferDocumentViewToken, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_Offer.actions.loadStatuses] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/customerOfferStatuses'

        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Offer.actions.loadFollowUpStatuses] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      var url = API_URL + '/api/v1/customerOfferFollowUpStatuses'
      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Offer.actions.resetState] ({ commit }) {
      commit(_Offer.mutations.setOffers, [])
      commit(_Offer.mutations.setUnconfirmedOffers, [])
      commit(_Offer.mutations.setSelectedOffer, null)
      commit(_Offer.mutations.setCustomerOfferDocumentViewToken, null)
    },
    [_Offer.actions.sendOfferMessage] (context, payload) {
      console.log('sendOfferMessage: ' + JSON.stringify(payload))
      var url = API_URL + '/api/v1/customerOffers/' + payload.id + '/sendOfferMessage'

      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        return axios.put(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    }
  },
  getters: {
    [_Offer.getters.offers] (state) {
      return state.offers
    },
    [_Offer.getters.unconfirmedOffers] (state) {
      return state.unconfirmedOffers
    },
    [_Offer.getters.getOpenDialogState] (state) {
      return state.openDialog
    },
    [_Offer.getters.getSelectedOffer] (state) {
      return state.setSelectedOffer
    },
    [_Offer.getters.getCreatingOfferForInquiry] (state) {
      return state.creatingCustomerOfferFromInquiry
    },
    [_Offer.getters.getCustomerOfferDocumentViewToken] (state) {
      return state.customerOfferDocumentViewToken
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/Offer/offers.js